import { defineBoot } from '#q-app'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'

// Instancia exportada para traducir FUERA de componentes (stores/servicios),
// usando `i18n.global.t('namespace.key')` igual que `$t` en plantillas.
export const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  globalInjection: true,
  messages
})

export default defineBoot(async ({ app }) => {
  // Tell app to use the I18n instance
  app.use(i18n)
})
